type CartCreationState = {
  cartNonExistentOrExpired: boolean;
  hasCareplanChanged: boolean;
  hasSellingPlans: boolean;
  isProfileLoading: boolean;
  cartCreationFailed: boolean;
};

export const shouldCreateCareplanCart = ({
  cartCreationFailed,
  cartNonExistentOrExpired,
  hasCareplanChanged,
  hasSellingPlans,
  isProfileLoading,
}: CartCreationState) => {
  const needsNewCart = cartNonExistentOrExpired || hasCareplanChanged;
  const alreadyFailedForThisCareplan = cartCreationFailed && !hasCareplanChanged;

  return needsNewCart && hasSellingPlans && !isProfileLoading && !alreadyFailedForThisCareplan;
};
